import styled from 'styled-components';

export const CourseMenuCellWrapper = styled.div`
  display: flex;
  justify-content: center;

  button {
    margin: 0;
  }
`;
